export enum MapSize {
    Hidden = 1,
    Small = 2,
    Medium = 4,
    Large = 8
}
